import { ButtonIcon, Table } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { alphaToggleAtom } from '../../atoms/alpha';
import { REACT_APP_AUTH_ROLE_OPERATOR } from '../../AuthProvider';
import Confirm from '../Confirm';
import Secured from '../Secured';
import RequestDataSyncMessages from './RequestDataSyncMessages';
import RequestEventsUpdate from './RequestEventsUpdate';
import RequestStreamsUpdate from './RequestStreamsUpdate';

export function RequestDataSync({ matchId }) {
  const intl = useIntl();
  const isAlphaEnabled = useAtomValue(alphaToggleAtom);
  const [displayConfirmation, setDisplayConfirmation] = useState();

  const handleClick = () => {
    setDisplayConfirmation(true);
  };

  return (
    <Secured allowed={REACT_APP_AUTH_ROLE_OPERATOR}>
      <ButtonIcon
        icon="Refresh"
        onClick={handleClick}
        title={intl.formatMessage({
          defaultMessage: 'Request Data Refresh',
          id: 'ce635',
        })}
        variant="secondary"
      />
      <Confirm
        id="data-refresh"
        isOpen={displayConfirmation}
        cancelLabel={null}
        confirmLabel={intl.formatMessage({
          defaultMessage: 'Close',
          id: 'd3d2e',
        })}
        onCancel={() => setDisplayConfirmation(false)}
        onConfirm={() => setDisplayConfirmation(false)}
        title={intl.formatMessage(
          {
            defaultMessage: 'Request Data Re-sync for #{matchId}',
            id: '552b8',
          },
          {
            matchId,
          },
        )}
      >
        {displayConfirmation && (
          <>
            <RequestDataSyncMessages />
            <Table>
              <Table.Head>
                <Table.HeaderCell colSpan={2}>
                  <FormattedMessage defaultMessage="Data Types" id="63788" />
                </Table.HeaderCell>
              </Table.Head>
              <Table.Body>
                <Table.Row>
                  <Table.DataCell $textAlign="left">
                    <FormattedMessage
                      defaultMessage="Request Statsbomb Data Re-sync For {matchId}"
                      id="ae42e"
                      values={{
                        matchId,
                      }}
                    />
                  </Table.DataCell>
                  <Table.DataCell $textAlign="left">
                    <RequestEventsUpdate matchId={matchId} />
                  </Table.DataCell>
                </Table.Row>
                {isAlphaEnabled && (
                  <Table.Row>
                    <Table.DataCell $textAlign="left">
                      <FormattedMessage
                        defaultMessage="Request Statsbomb Data Re-sync For The Competition Season"
                        id="64288"
                        values={{
                          matchId,
                        }}
                      />
                    </Table.DataCell>
                    <Table.DataCell $textAlign="left">
                      <RequestEventsUpdate
                        matchId={matchId}
                        requestSeasonUpdate
                      />
                    </Table.DataCell>
                  </Table.Row>
                )}
                <Table.Row>
                  <Table.DataCell $textAlign="left">
                    <FormattedMessage
                      defaultMessage="Request Global Sports Library Stream Re-sync For {matchId}"
                      id="44f73"
                      values={{
                        matchId,
                      }}
                    />
                  </Table.DataCell>
                  <Table.DataCell $textAlign="left">
                    <RequestStreamsUpdate matchId={matchId} />
                  </Table.DataCell>
                </Table.Row>
                {isAlphaEnabled && (
                  <Table.Row>
                    <Table.DataCell $textAlign="left">
                      <FormattedMessage
                        defaultMessage="Request Global Sports Library Stream Re-sync For The Competition Season"
                        id="d2afe"
                      />
                    </Table.DataCell>
                    <Table.DataCell $textAlign="left">
                      <RequestStreamsUpdate
                        matchId={matchId}
                        requestSeasonUpdate
                      />
                    </Table.DataCell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </>
        )}
      </Confirm>
    </Secured>
  );
}

RequestDataSync.propTypes = {
  matchId: PropTypes.string.isRequired,
};
export default { RequestDataSync };
